module.exports = {
  sanity: {
    projectId: process.env.GATSBY_SANITY_PROJECT_ID || 'uvdp4b76',
    dataset: process.env.GATSBY_SANITY_DATASET || 'showcase-spr-2024-test',
  },
  gatsby: {
    siteTitle: 'Spring Show | Academy of Art University',
    siteDescription:
      'At the Academy of Art University, you don’t just imagine a better world, you learn the skills to help create one.  Spring Show showcases the achievements of graduating students across our 22 different schools. Meet the future of art and design.',
    siteUrl: 'https://springshow.academyart.edu', // Site domain. Do not include a trailing slash! If you wish to use a path prefix you can read more about that here: https://www.gatsbyjs.org/docs/path-prefix/
    userTwitter: '@academy_of_art', // Change for Twitter Cards
    author: 'Academy of Art University', // Author for RSS author segment and SEO schema
    authorUrl: 'https://www.academyart.edu', // URL used for author and publisher schema, can be a social profile or other personal site
    shortTitle: 'Academy of Art University Spring Show', // Used for App manifest e.g. Mobile Home Screen
  },
};
